export default {"src":"/_next/static/media/rocketFour.f05eb097.svg","height":25,"width":25};